export default __webpack_public_path__ + "static/forecast-poster-24a60a2923527d220bdb7c9bb49289c3.jpg";